import '../../App.scss'
import ReactHtmlParser from "react-html-parser";
import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import Seo from '../seo/Seo'
export default class ViewGlyph extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                title: '',
                content: ''
            }
        };
    }
    async componentDidMount() {
        const { blogid, postid } = this.props.match.params
        await fetch(`https://www.googleapis.com/blogger/v3/blogs/${blogid}/posts/${postid}?key=AIzaSyDncvsDJ8auOX6KnFm3Vl9qHDdgbkB6oRQ`)
            .then(response => response.json())
            .then(data => this.setState({ data: data }));
        }
        render() {
        let { title, content } = this.state.data
        let newTitle = title.toString()
        console.log(newTitle)
        let div = document.createElement('div');
        div.innerHTML = content;
        let firstImage = div.getElementsByTagName('img')[0]
        let imgSrc = firstImage ? firstImage.src : "";
        return (
            <div className="ViewGlyph">
           <Seo
             title={'Mystery Glyph Panel: ' + newTitle}
             description={"Mystery Glyphs"}
             image={imgSrc}
             />
              
                <div className="ArticleContent">
                    <h1>{title}</h1>
                    {ReactHtmlParser(content)}
                </div>
            </div>
        );

    }
}
